import React, { useEffect } from 'react'
// import { useLocation} from 'react-router-dom'

import urls from '../../../utils/constants/urls'
import LoadingSpinner from '../../elem/LoadingSpinner'

const CallbackComponent = () => {
    useEffect(() => {
        const t = setTimeout(() => {
            window.location = urls.home
            return null
        }, 5000)
        return () => clearTimeout(t)
    }, [])

    return (
        <div className="hero is-large">
            <div className="hero-body">
                <div className="container has-text-centered">
                    <p className="title">
                        <div className="callbackSpinnerWrapper">
                            <LoadingSpinner size={'4rem'}/>
                        </div>
                    </p>
                    <p className="subtitle authorizationMessage">Authorizing...</p>
                </div>
            </div>
        </div>
    )
}

export default CallbackComponent
